module.exports = __webpack_public_path__ + "img/img-11.37b30674.svg";